import Resource from '@/api/Resource';
import User from './User';

export default class extends Resource {
  $name = 'roles';

  $defaults() {
    return {
      id: null,
      name: '',
      title: '',
      title_plural: '',
    };
  }

  $fill({ users, permissions }) {
    if (users) {
      this.users = User.collection(users);
    }

    if (permissions) {
      let result = {};
      permissions.forEach(({ name, action }) => {
        if (!result[name]) {
          result[name] = {};
        }
        result[name][action] = true;
      });
      this.permissions = result;
    }
  }

  can(name, action = null) {
    if (this.permissions) {
      if (this.permissions['*'] || this.permissions[name]) {
        if (action) {
          return this.permissions[name]['*'] || this.permissions[name][action];
        }
        return true;
      }
    }
    return false;
  }
}
